export const ADMIN_QUERIES = {
  AGENT_STAFF: 'agent_staff',
  TABLE_ID: 'agent_table_id',
  IS_ADMIN: 'is_admin',
  MY_TABLE: 'my_table',
  ADD_GIFTS: 'add_gifts',
  AGENT_TOKEN: 'agent_token',
  ADMIN_HEADER: 'admin',
};
